import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import {
  SSection,
  SPostSection,
  SSectionTitle,
  SPostImage,
  SPostDetails,
  SPostTitle,
  SPostDate,
} from './styles';
import { getImage } from 'gatsby-plugin-image';

function LatestBlogPostsCard({ isPodcasts, posts = [] }) {
  return (
    <SSection>
      <SSectionTitle>
        Latest {isPodcasts ? 'Podcast' : 'Blog Posts'}
      </SSectionTitle>
      {posts.map(post => {
        const image = post.featuredImage
          ? getImage(post.featuredImage.node.localFile)
          : null;
        return (
          <Link
            to={`/${isPodcasts ? 'podcast' : 'blog'}/${post.slug}/`}
            key={post.id}
          >
            <SPostSection>
              <SPostImage
                image={image}
                alt={post.featuredImage?.node.altText}
              />
              <SPostDetails>
                <SPostTitle>{post.title}</SPostTitle>
                <SPostDate>{post.date}</SPostDate>
              </SPostDetails>
            </SPostSection>
          </Link>
        );
      })}
    </SSection>
  );
}

LatestBlogPostsCard.propTypes = {
  isPodcasts: PropTypes.bool,
  posts: PropTypes.array,
};

export default LatestBlogPostsCard;
